<div class="toast-container">
  <button [ngClass]="['type', type]" aria-label="Icon" disabled mat-icon-button>
    <mat-icon>{{ icon }}</mat-icon>
  </button>
  <span class="message">{{ message }}</span>
  <button (click)="onDismiss()" aria-label="Dismiss" class="small dismiss" mat-icon-button>
    <mat-icon>close</mat-icon>
  </button>
</div>
